import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import AppConfig from "../../constants/AppConfig";
import { GetWarrantyRequest, CorpWarrantyRequestById } from "../../store/sagas/Warranty";
import { StoreContext } from "../../store/StoreProvider";
import { types } from "../../store/Warranty";
import Loading from "../Loading";
import { Alert } from "../Alert";
import { getI18N } from '../../i18n';

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { Button } from "@material-ui/core";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from "@material-ui/core";

const {
  functions: { setColorWarrantyState },
  colors: { blueblack }
} = AppConfig;

interface SaleListItemProps { }

export const SaleListItem = (props: any) => {
  const [store, dispatch] = React.useContext(StoreContext);
  const [loading, setLoad] = React.useState(false);
  const AlertRef = React.useRef<any>();

  const { Country } = store?.user;
  const currentLocale: string = Country || "PE";
  const i18n = getI18N({ currentLocale })

  const setDetail = () => {

    let idMiniCod = !!props?.IdMiniCod ? props?.IdMiniCod : `D${props?.DocEntry}`
    setLoad(true);
    let obj = {
      idTarjeta: props?.IdTarjeta,
      idMiniCod: idMiniCod,
      cardCode: store?.selected_client.Id,
    };

    const objCorp = {
      IdSolicitudGarantia: props?.IdSolicitud
    }

    CorpWarrantyRequestById(objCorp).then((response) => {
      if (response?.statusCode !== 200) {
        setLoad(false);
        AlertRef?.current?.open(response.message ?? "No se encontraron resultados", 'error')
        // alert(response?.message ?? "No se encontraron registros");
      }

      if (response?.statusCode === 200) {
        dispatch({ type: types.setWarrantyDetail, payload: response?.value });
        setLoad(false);
        props?.callback();

      }
    })
    return;
  };

  return (
    <>
      <TableRow>
        <TableCell colSpan={4} align="left" sx={{ border: 0, padding: 0 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Box className="col">
                  <h3 className="w-title" style={{ margin: 5, marginLeft: 20 }}>
                    {props.NombreCliente}
                  </h3>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="col">
                  <h3 className="w-title" style={{ margin: 5, marginLeft: 0 }}>
                    RUC: {props?.NroDocumento}
                  </h3>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </TableCell>
      </TableRow>

      <TableRow
        key={props?.Id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell
          scope="row"
          style={{ minWidth: 200, margin: 5, marginLeft: 20 }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Box className="col">
                  <span className="w-title">Fecha de venta</span>
                  <span className="w-subtitle">
                    {props?.dFechaVenta ? moment(props?.dFechaVenta).format("DD-MM-YYYY") : ""}
                  </span>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="col">
                  <span className="w-title">N de baterias vendidas</span>
                  <span className="w-subtitle">{props.Baterias?.length}</span>
                </Box>
              </Grid>


            </Grid>
          </Box>

          <Box>
            <Accordion defaultExpanded className="container-accordion-sale" style={{ boxShadow: "none" }}>
              <AccordionSummary
                // expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography variant="h6" style={{ fontWeight: "bold", textAlign: "left", display: 'flex', alignItems: 'center', gap: '0.5rem' }}>Baterías <ExpandMoreIcon /></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <TableContainer className="container-table-list">
                    <Table className="w-table" aria-label="simple table" stickyHeader size="small">
                      <TableBody>

                        {props.Baterias?.map((item: any, index: number) => (
                          <TableRow key={Math.random()} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell width={"10%"}><span className="w-title">{item.Minicod}</span></TableCell>
                            <TableCell width={"20%"}><span className="w-title">{item.cModelo}</span></TableCell>
                            <TableCell width={"2%"} align="center">
                              {item.Estado === 1 ? (
                                <CheckCircleIcon color="success" fontSize="small" />
                              ) : (
                                <CancelIcon color="error" fontSize="small" />
                              )}
                            </TableCell>
                            <TableCell width={"10%"}>
                              {item.Estado === 1 && (
                                <Button variant="contained" size="small" style={{ borderRadius: "20px" }} onClick={(e) => {
                                  e.preventDefault();

                                  dispatch({
                                    type: types.setWarrantyActivationMiniCodeList,
                                    payload: [],
                                    searchMiniCode: item.Minicod,
                                    warrantyTab: 3,
                                    activeSearch: true
                                  });
                                }}>VER</Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>

        </TableCell>
      </TableRow>

      {/* <Alert ref={AlertRef} /> */}
    </>
  );
};
